let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("id7xn")).then(() => parcelRequire('jkONz'));